<script setup lang="ts">
import { computed } from "vue";

import TeamsList from "@Modules/teams/components/TeamsList.vue";
import PermissionDenied from "@Modules/teams/components/PermissionDenied.vue";
import type { Organization } from "@Modules/teams/Data/Models/OrganizationModel.ts";
import type { Team } from "@Modules/teams/Data/Models/TeamModel.ts";
import V2Footer from "@Modules/shared/Components/V2Footer.vue";

//
// Props
interface Props {
  organization: Organization | null;
  workspace?: Team | null;
  isDebug?: boolean;
  loading?: boolean;
  can?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  workspace: null,
  isDebug: false,
  loading: false,
  can: true,
});

//
// Computed
const workspaces = computed<Array<Team>>(() => props.organization?.teams || []);
</script>

<template>
  <div
    v-cloak
    class="teams-layout"
  >
    <TeamsList
      v-if="isDebug && organization"
      :org="organization"
      :workspaces="workspaces"
      :is-loading="loading"
    />
    <div class="teams-layout__content">
      <template v-if="can">
        <slot />
      </template>
      <PermissionDenied v-else />
    </div>
    <V2Footer />
  </div>
</template>

<style lang="scss" scoped>
.teams-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
}
</style>
